import { useMemo } from 'react';
import { useGetMemberIndividualResultsQuery } from '../state/api';
import MemberIndividualHistory from './member-individual-history';

interface MemberIndividualNontournamentHistoryContainerProps {
  member_id: string | undefined;
}

const MemberIndividualNonTournamentHistoryContainer = ({
  member_id,
}: MemberIndividualNontournamentHistoryContainerProps) => {
  const { data: results = [] } = useGetMemberIndividualResultsQuery(member_id!, {
    skip: member_id === undefined,
  });

  const history = useMemo(
    () =>
      results
        .filter((res) => res.competitionSeries !== 'Crazy English Tournament')
        .map((res) => ({
          date: res.date ?? '',
          description: res.competitionSeries ?? '',
          position: res.position,
          points: res.points,
        })),
    [results]
  );

  return <MemberIndividualHistory history={history} descriptionLabel="Competition" />;
};

export default MemberIndividualNonTournamentHistoryContainer;
